import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { usePages } from "../../Context/pagesContext";

const TermsAndCondition = () => {
  const { t } = useTranslation();
  const { termsAndConditions, loading, error, fetchTermsAndConditions } =
    usePages();
  const [modifiedHtml, setModifiedHtml] = useState("");

  useEffect(() => {
    if (termsAndConditions?.description) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(
        termsAndConditions.description,
        "text/html"
      );

      // Add classes to <h5>
      doc.querySelectorAll("h5").forEach((el) => {
        el.classList.add("text-dark", "mb-4", "fw-bold");
      });

      // Add classes to <p> and append <hr /> after each <p>
      doc.querySelectorAll("p").forEach((el) => {
        el.classList.add("fs-6", "text-muted");

        // Create <hr> and append it after <p>
        const hr = document.createElement("hr");
        el.parentNode.insertBefore(hr, el.nextSibling);
      });

      // Add classes to <strong>
      doc.querySelectorAll("strong").forEach((el) => {
        el.classList.add("ms-1");
      });

      // Serialize the modified HTML
      setModifiedHtml(doc.body.innerHTML);
    }
  }, [termsAndConditions]);

  // Fetch all data on mount
  useEffect(() => {
    fetchTermsAndConditions();
  }, []);

  if (loading) {
    return <div className="loading">{t("Loading...")}</div>;
  }

  if (error) {
    return (
      <div className="error">{t("Error loading terms and conditions.")}</div>
    );
  }

  return (
    <>
      <div className="container-fluid faq-heading">
        <div className="row">
          <h1>{t("Terms & Conditions")}</h1>
          <p>
            {t("Please read these terms carefully before using our services.")}
          </p>
        </div>
      </div>
      <div className="container my-5">
        <div className="row">
          <div className="col-12">
            <div className="card shadow border-0 rounded-0 overflow-hidden">
              <div className="card-body bg-light">
                {/* Render the termsAndConditions content dynamically */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: modifiedHtml || "",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;
